// extracted by mini-css-extract-plugin
export default {"cls1":"P5TXVlZ2U9_2b3Yr65To","cls2":"pHl1D2unqb_wcMGHp6cc P5TXVlZ2U9_2b3Yr65To","isTabletDown":"JkZmgFV8NvMHH4EMxK1A","isDesktopUp":"TI0Py48NndRAlm1NDAsh"};